import { Box, BoxProps } from '@mui/material'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import AutorenewIcon from '@mui/icons-material/Autorenew'

// Composite icon for the "autosave" toggle: the standard save outline
// with a small gold (primary-theme) autorenew badge tucked into the
// bottom-right corner. Drops in anywhere an MUI SvgIcon would go -
// `sx={{ fontSize: ... }}` controls the rendered size and `opacity`
// works as expected.
export default function AutosaveIcon(props: Omit<BoxProps, 'component'>) {
  const { sx, ...rest } = props
  return (
    <Box
      {...rest}
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1em',
        height: '1em',
        fontSize: 'inherit',
        lineHeight: 1,
        verticalAlign: 'middle',
        ...sx,
      }}
    >
      <SaveOutlinedIcon sx={{ fontSize: 'inherit', color: 'primary.main' }} />
      <AutorenewIcon
        sx={{
          position: 'absolute',
          right: '-20%',
          bottom: '-20%',
          fontSize: '0.7em',
          color: 'primary.main',
          // White halo so the badge reads against the underlying save
          // icon's strokes - the autorenew arrows otherwise fight the
          // floppy-disk outline.
          filter: 'drop-shadow(0 0 1px #fff) drop-shadow(0 0 1px #fff)',
        }}
      />
    </Box>
  )
}
